module.exports = "/assets/delice-page/awarded@2x.jpg?/xTHl36";